import {
  Box,
  Grid,
  Slide,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import { CustomBtn } from "../components/Common/CustomBtn";
import { colors } from "../theme/theme";
import MembershipModal from "../components/Modals/MembershipModal";
import TermsAndConditions from "../components/Modals/TermsAndConditions";
import PrivacyPolicyModal from "../components/Modals/PrivacyPolicyModal";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AuthLayout = ({ children, fullHeight = false }) => {
  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const mdScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [membershipModalState, setMembershipModalState] = useState(false);
  const [termsModalState, setTermsModalState] = useState(false);
  const [privacyModalState, setPrivacyModalState] = useState(false);

  return (
    <>
      <Grid
        container
        sx={{
          height: "100vh",
          overflow: "hidden",
          backgroundImage: `url(${require("../assets/images/bg-image1.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          transition: "filter 0.3s ease",
          filter: membershipModalState ? "blur(20px)" : "none",
        }}
      >
        {!smScreen && (
          <Grid
            item
            size={{ xs: 0, sm: 6 }}
            sx={{
              height: "100%",
              py: 4,
              pl: 6,
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <img
                src={require("../assets/icons/logo_md.png")}
                alt="Logo"
                style={{ height: "70px", width: "30%", objectFit: "contain" }}
              />
              <Box>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: {
                      sm: "30px",
                      md: "50px",
                    },
                    fontFamily: "Mulish-Light",
                    lineHeight: mdScreen ? "40px" : "60px",
                    letterSpacing: mdScreen ? "1px" : "0.5px",
                    maxWidth: "80%",
                  }}
                >
                  Join events, discuss, and{" "}
                  <Typography
                    component="span"
                    sx={{
                      fontSize: {
                        sm: "30px",
                        md: "50px",
                      },
                      fontFamily: "Mulish-Bold",
                      color: "#fff",
                      lineHeight: mdScreen ? "40px" : "60px",
                      letterSpacing: mdScreen ? "1px" : "0.5px",
                    }}
                  >
                    connect with like-minded people.
                  </Typography>
                </Typography>

                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "16px",
                    my: 2.5,
                    fontFamily: "Mulish-Light",
                  }}
                >
                  Engage in meaningful discussions and exclusive events.
                </Typography>

                <CustomBtn
                  text="Apply for Membership"
                  icon
                  secondary
                  bgcolor={"rgba(247,132,25,0.5)"}
                  border={`1px solid ${colors.secondary}`}
                  gradientBorder
                  height={"60px"}
                  width={mdScreen ? "75%" : "40%"}
                  fontSize={"16px"}
                  onClick={() => setMembershipModalState(true)}
                />
              </Box>

              <Stack direction="row" gap={2} alignItems="center">
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "13px",
                    fontFamily: "Mulish-Light",
                    cursor: "pointer",
                    textTransform: "uppercase",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                  onClick={() => setTermsModalState(true)}
                >
                  Terms & conditions
                </Typography>
                <Box
                  sx={{
                    height: "20px",
                    width: "1px",
                    bgcolor: "rgba(255,255,255,0.32)",
                  }}
                />
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "13px",
                    fontFamily: "Mulish-Light",
                    cursor: "pointer",
                    textTransform: "uppercase",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                  onClick={() => setPrivacyModalState(true)}
                >
                  Privacy Policy
                </Typography>
              </Stack>
            </Box>
          </Grid>
        )}
        <Grid
          item
          size={{ xs: 12, sm: 6 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Box
            sx={{
              px: 4,
              py: fullHeight ? 4 : 2,
              backgroundColor: "white",
              borderRadius: "40px",
              boxShadow: "0px 20px 20px 0px #191D29",
              backgroundImage: `url(${require("../assets/images/bg-image.png")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundBlendMode: "overlay",
              width: "65%",
              height: fullHeight ? "80%" : "auto",
            }}
          >
            {children}
          </Box>
        </Grid>
      </Grid>

      <MembershipModal
        open={membershipModalState}
        handleClose={() => setMembershipModalState(false)}
        Transition={Transition}
      />
      <TermsAndConditions
        open={termsModalState}
        handleClose={() => setTermsModalState(false)}
        Transition={Transition}
      />
      <PrivacyPolicyModal
        open={privacyModalState}
        handleClose={() => setPrivacyModalState(false)}
        Transition={Transition}
      />
    </>
  );
};

export default AuthLayout;
